module.exports = __webpack_public_path__ + "static/img/guest25.7618135.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/guest25.png
// module id = hB8k
// module chunks = 0